import { render } from "./News22.vue?vue&type=template&id=5e097c84"
import script from "./News22.vue?vue&type=script&lang=js"
export * from "./News22.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__